import React from 'react';
import ICN from './pageIcons';

const FACET_DEFS = [
    ['language', 'Language', 'Any'],
    ['status', 'Status', 'Any'],
    ['owner', 'Owner', 'Anyone'],
    ['due', 'Due', 'Anytime'],
];

const Toolbar = ({ q, setQ, view, setView, facets, toggleFacet, clearFacets, sort, setSort }) => {
    const anyApplied = Object.values(facets).some((v) => v && v !== 'Any' && v !== 'Anyone' && v !== 'Anytime');
    return (
        <div className="rs-toolbar">
            <div className="rs-tb-search">
                {ICN.search}
                <input
                    placeholder="Search projects, files, terms…"
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                />
                <span className="kbd">/</span>
            </div>
            {FACET_DEFS.map(([k, label, def]) => {
                const v = facets[k] || def;
                const applied = v !== def;
                return (
                    <button
                        key={k}
                        type="button"
                        className={`rs-tb-facet ${applied ? 'applied' : ''}`}
                        onClick={() => toggleFacet(k)}
                    >
                        <span className="lbl-k">{label}:</span>
                        <span className="lbl-v">{v}</span>
                        {ICN.caret}
                    </button>
                );
            })}
            {anyApplied && (
                <button type="button" className="rs-tb-facet" onClick={clearFacets} style={{ color: 'var(--ink-3)' }}>
                    {ICN.x}<span style={{ fontWeight: 500 }}>Clear</span>
                </button>
            )}
            <div className="rs-tb-spacer" />
            <button type="button" className="rs-tb-facet" onClick={() => setSort(sort === 'due' ? 'name' : sort === 'name' ? 'progress' : 'due')}>
                <span className="lbl-k">Sort:</span>
                <span className="lbl-v">{sort === 'due' ? 'Due date' : sort === 'name' ? 'Name' : 'Progress'}</span>
                {ICN.caret}
            </button>
            <div className="rs-tb-view">
                <button type="button" className={view === 'table' ? 'on' : ''} onClick={() => setView('table')} aria-label="Table">{ICN.vTable}</button>
                <button type="button" className={view === 'board' ? 'on' : ''} onClick={() => setView('board')} aria-label="Board">{ICN.vBoard}</button>
                <button type="button" className={view === 'timeline' ? 'on' : ''} onClick={() => setView('timeline')} aria-label="Timeline">{ICN.vTime}</button>
            </div>
        </div>
    );
};

export default Toolbar;
